import { useState, useEffect, useCallback } from "react";
import { toast } from "sonner";
import { productApi } from "@/lib/api";
import { CompaniesTab } from "@/pages/UserManagement";
import { ProductModeBanner } from "@/components/ProductModeBanner";

export default function ProductCompanies() {
  const [companies, setCompanies] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [publishers, setPublishers] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const [c, camp, pub] = await Promise.all([productApi.getCompanies(), productApi.getCampaigns(), productApi.getPublishers()]);
      setCompanies(c.data); setCampaigns(camp.data); setPublishers(pub.data);
    } catch { toast.error("Failed to load companies"); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="p-6 max-w-7xl mx-auto space-y-5" data-testid="product-companies-page">
      <ProductModeBanner />
      {loading ? (
        <div className="flex items-center justify-center h-40"><div className="w-6 h-6 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" /></div>
      ) : (
        <CompaniesTab companies={companies} campaigns={campaigns} publishers={publishers} onReload={load}
          api={productApi} isProduct previewBase="/product/preview" />
      )}
    </div>
  );
}
